import { createContext, type FC, type ReactNode } from 'react';

type HeaderFooterServerVarsContext = {
    buyerHost: string;
    isMobile: boolean;
    isTablet?: boolean;
    isMwSearchBarVariant?: boolean;
    showCompactedHeader?: boolean;
};

export const HeaderFooterServerVarsContext = createContext<HeaderFooterServerVarsContext>({
    isMobile: false,
    buyerHost: '',
});

type Props = {
    children: ReactNode;
    isMobile: boolean;
    isTablet?: boolean;
    buyerHost: string;
    isMwSearchBarVariant?: boolean;
    showCompactedHeader?: boolean;
};

export const HeaderFooterServerVarsContextProvider: FC<Props> = ({
    children,
    buyerHost,
    isMobile,
    isTablet,
    isMwSearchBarVariant,
    showCompactedHeader,
}) => (
    <HeaderFooterServerVarsContext.Provider
        value={{ buyerHost, isMobile, isTablet, isMwSearchBarVariant, showCompactedHeader }}
    >
        {children}
    </HeaderFooterServerVarsContext.Provider>
);
